;(function() {
    'use strict';

    angular
        .module('elogbooks.common.files')
        .controller('CommonManageFilesController', CommonManageFilesController);

    CommonManageFilesController.$inject = [
        'sectionResource',
        'modulesService'
    ];

    function CommonManageFilesController(
        sectionResource,
        modulesService
    ) {
        var vm = this;
        vm.sectionResource = sectionResource;
        vm.auditsModuleEnabled = modulesService.isEnabled('audits_module');
        vm.quotesModuleEnabled = modulesService.isEnabled('quotes');
    }
})();
